module.exports = __webpack_public_path__ + "media/images/top-parts-09-6cfcec8cd2454cfb9c107e6bfbfe9496.jpg";